import React, { useContext, useState } from "react";
import { CommonModal } from "components";
import { UserContext } from "context";
import { Document, Page } from "@react-pdf/renderer";
import { FaFilePdf } from "react-icons/fa6";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const AttachedFileModal = (props) => {
  const { showAttachedModal } = props;
  const { masterData } = useContext(UserContext);
  const [imageUrl, setImageUrl] = useState(showAttachedModal?.data[0]);

  const isPdfFile = (path) => path?.endsWith(".pdf");

  return (
    <CommonModal {...props}>
      <div className="_attFile_body">
        <div className="__shwAtt_imgBx">
          {/* Display either the PDF or zoomable image */}
          {isPdfFile(imageUrl) ? (
            <div className="pdf-viewer">
              <Document file={imageUrl}>
                <Page pageNumber={1} />
              </Document>
            </div>
          ) : (
           
            <Zoom   zoomMargin={20} overlayBgColorEnd="rgba(0,0,0,0.9)">
              <img
                src={imageUrl}
                alt="Attachment"
                className="zoomable-image"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain", // Ensures it fits inside the box
                  maxWidth: "400px", // Adjust based on modal size
                  maxHeight: "400px",
                  border: "1px solid #ddd",
                  background: "#fff",
                }}
              />
            </Zoom>
           
          )}
        </div>

        <div className="img_fnex_src">
          {showAttachedModal?.data?.length &&
            showAttachedModal?.data?.map((i, index) => (
              <div
                className="pos-relative"
                style={{ cursor: "pointer" }}
                onClick={() => setImageUrl(i)}
                key={index}
              >
                {isPdfFile(i) ? (
                  <FaFilePdf size={50} color="#d9534f" />
                ) : (
                  <img className="_pdfIcon_sigxe" src={i} alt="Thumbnail" />
                )}
              </div>
            ))}
        </div>
      </div>
    </CommonModal>
  );
};

export default AttachedFileModal;
